/**
 * V3: Facet Loader
 *
 * Dynamically injects the loading animation to any FacetWP enabled pages and
 * hide/show the loader depending on status.
 */


// Dependencies
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
    let firstInit = false;
    let loader = $('<div class="v3-facet-loader"><video src="/wp-content/themes/ON24/videos/on24_spinner.webm" width="96" height="96" preload autoplay loop muted></video></div>')

	document.addEventListener('facetwp-loaded', function() 
    {
        if (!firstInit)
        {
            loader.appendTo(document.body);
            firstInit = true;
        }

        loader.removeClass('loading');
    });

    document.addEventListener('facetwp-refresh', function() 
    {
        loader.addClass('loading');
    });
}

// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
